import Container from '@material-ui/core/Container';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useGlobal } from '@rcg/ui-react';
// eslint-disable-next-line import/no-named-as-default
import Fields from './fields';
import useStyles from './index.style';
import { validationSchema } from './index.validation';
import useLdFlags from '../../hooks/useLdFlags';
import { ENABLE_TRAVEL_DOCUMENT_FIELD } from '../../commons/ld-user';

export default (reservation) => {
  const {
    renderContent,
    data: { lang },
  } = useGlobal();
  const classes = useStyles();
  const [enableTravelDocument, setEnableTravelDocument] = useState();
  const [flags, setFlags] = useState();

  const [ldFlagsParams, setldFlagsParams] = useState({
    country: '',
    language: '',
  });

  useEffect(() => {
    const ldFlagsCountry = reservation?.country;
    const ldFlagsCurrency = reservation?.price.currencyCode;
    setldFlagsParams({
      ...ldFlagsParams,
      ldFlagsCountry,
      language: lang,
      currency: ldFlagsCurrency,
    });
  }, []);

  const { ldFlags } = useLdFlags(ldFlagsParams);

  useEffect(() => {
    if (ldFlags) {
      setFlags(ldFlags);
      setEnableTravelDocument(ldFlags[ENABLE_TRAVEL_DOCUMENT_FIELD]);
    }
  }, [ldFlags]);

  return (
    <Container className={classes.root}>
      <Formik
        initialValues={reservation}
        validationSchema={validationSchema(renderContent, enableTravelDocument)}>
        {(props) => {
          return <Fields {...{ ...props, ...reservation, flags }} />;
        }}
      </Formik>
    </Container>
  );
};
